import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContainer from "./shared/components/ThemeContainer";
import GlobalStyle from "./shared/styles/GlobalStyle";
import 'antd/dist/antd.min.css'
import "./web.config";
import {HashRouter as Router} from "react-router-dom";
import MenuWrapper from "./shared/components/menu/MenuWrapper";
import {AppProvider} from "./shared/context/AppContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <Router>
        <MenuWrapper/>
        <ThemeContainer>
          <GlobalStyle/>
          <App />
        </ThemeContainer>
      </Router>
    </AppProvider>
  </React.StrictMode>
);

reportWebVitals();
